import React from 'react';
import { Outlet } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";

import FooterReserved from "./innerComponent/FooterReserved";
import LargeFooter from "./ProfileLayout/FOOTER/LargeFooter";
import ScrollToTop from "../components/other/ScrollToTop";

import "./innerComponent/styles/navbarmenu.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Navbar from "./Navbar";
import NavbarMenu from "./innerComponent/NavbarMenu";


const Layout = () => {

  return (
    <React.Fragment>
      <CssBaseline />
      <ScrollToTop />
      <Box
        sx={{
          maxWidth: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: 'white.main',
          minHeight: "100vh",
          margin: 0,
          padding: 0,
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: { md: 105, xl: 120 },
            backgroundColor: '#ffffffff',
            overflow: 'hidden',
            transition: 'top 0.38s cubic-bezier(0.25, 0.8, 0.25, 1)',
            willChange: 'top',
          }}
        >
          <Navbar />
          <NavbarMenu />
        </Box>

        <Box
          component="main"
          sx={{
            flex: 1,
            width: "100%",
            height: "100%",
          }}
        >
          <Outlet />
        </Box>

        {/* Footer Section */}
        <Box sx={{ width: "100%" }}>
          <LargeFooter />
          <FooterReserved />
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default React.memo(Layout);
